import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

//判断是否为销售角色
let handleIsSaleRole = function(state){
  let isSaleRole = false;
  let roles = state.roles;
  if (roles && roles.length) {
    roles.forEach((item) => {
      if (item.indexOf("销售") != -1) {
        isSaleRole = true;
      }
    });
  }
  return isSaleRole;
}
const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    info:{},
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_ADMIN: (state, info) => {
      state.info = info
      state.info.isSaleRole = handleIsSaleRole(state);
    }
  },

  actions: {
    setAdmin({ commit }, info){
      return new Promise(resolve => {
        console.log('更新')
        commit('SET_ADMIN', info)
        resolve()
      })
    },
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
            // console.log('我要弄按钮了-----------',response.data)
            // commit('SET_PERMISSIONS', ['*:*:*'])
            commit('SET_PERMISSIONS', response.data.permissions?response.data.permissions:[])
            let umsAdmin=response.data.umsAdmin?response.data.umsAdmin:{}
            umsAdmin.icon=response.data.icon
            commit('SET_ADMIN', umsAdmin)

          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          if (data.menus && data.menus.length) {
            commit('SET_MENUS', data.menus)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js